import { TObject } from '@infinex-private/ts-utils/object';

/**
 * Configuration for the "Open Runde" font.
 * @see https://github.com/lauridskern/open-runde
 */
export const INITIALS_FONT = {
  name: 'OpenRunde',
  options: { weight: '700', style: 'normal', display: 'swap' },
  url: async () =>
    (await import('@infinex/ui-fonts/open-runde/OpenRunde-Bold.woff2?url'))
      .default,
} as const satisfies {
  name: string;
  options: FontFaceDescriptors;
  url: () => Promise<string>;
};

export const SIZES = {
  xsmall: { element: 20, emoji: 12, font: 12, icon: 12 },
  small: { element: 24, emoji: 14, font: 14, icon: 14 },
  medium: { element: 32, emoji: 18, font: 20, icon: 20 },
  large: { element: 40, emoji: 20, font: 24, icon: 24 },
  xlarge: { element: 56, emoji: 30, font: 30, icon: 32 },
  extraLarge: { element: 72, emoji: 36, font: 36, icon: 36 },
} as const;

// tailwind fuckery: can't use computed values, need string literals for class detection…
// at least this way the class names are forced to match the JS values
export const SIZE_CLASSES: {
  [K in keyof typeof SIZES]: {
    element: `sizepx-${(typeof SIZES)[K]['element']}`;
    emoji: `textpx-${(typeof SIZES)[K]['emoji']}`;
    font: `textpx-${(typeof SIZES)[K]['font']}`;
    icon: `sizepx-${(typeof SIZES)[K]['icon']}`;
  };
} = {
  xsmall: {
    element: 'sizepx-20',
    emoji: 'textpx-12',
    font: 'textpx-12',
    icon: 'sizepx-12',
  },
  small: {
    element: 'sizepx-24',
    emoji: 'textpx-14',
    font: 'textpx-14',
    icon: 'sizepx-14',
  },
  medium: {
    element: 'sizepx-32',
    emoji: 'textpx-18',
    font: 'textpx-20',
    icon: 'sizepx-20',
  },
  large: {
    element: 'sizepx-40',
    emoji: 'textpx-20',
    font: 'textpx-24',
    icon: 'sizepx-24',
  },
  xlarge: {
    element: 'sizepx-56',
    emoji: 'textpx-30',
    font: 'textpx-30',
    icon: 'sizepx-32',
  },
  extraLarge: {
    element: 'sizepx-72',
    emoji: 'textpx-36',
    font: 'textpx-36',
    icon: 'sizepx-36',
  },
};

export const INITIALS_PROPORTION = 0.7; // relative to the size of the avatar
export const MAX_INITIALS_WIDTH: Record<keyof typeof SIZES, number> =
  TObject.fromEntries(
    TObject.entries(SIZES).map(([key, { element }]) => [
      key,
      Math.round(element * INITIALS_PROPORTION),
    ])
  );
